import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { extend } from '@thd-nucleus/data-sources';
import { isGenericProduct } from '../../utils';
import { ProductPodContext } from '../../ProductPodContext';

export const ProductStore = ({ checkGeneric, className }) => {
  const {
    product,
    isScheduleAMeasureEligible,
    onCheckNearbyStoresClick,
  } = useContext(ProductPodContext);

  const { channel } = useContext(ExperienceContext);
  if ((checkGeneric && isGenericProduct(product)) || isScheduleAMeasureEligible) return null;
  const storeClasses = classNames('product-pod__fulfillment--store', className, {
    'product-pod__fulfillment--store--mobile': channel === 'mobile'
  });

  if (!product?.fulfillment) return null;

  return (
    <div className={storeClasses}>
      <FulfillmentPodStore
        product={product}
        onCheckNearbyStoresClick={onCheckNearbyStoresClick}
      />
    </div>
  );
};

ProductStore.propTypes = {
  checkGeneric: bool,
  className: string
};

ProductStore.defaultProps = {
  checkGeneric: false,
  className: null
};

ProductStore.displayName = 'ProductStore';

ProductStore.dataModel = extend(
  FulfillmentPodStore,
);
